
export interface IEntryPageOption {
    title: string;
    description: string;
    value: number;
}

export interface IEntryPageConfiguration {
    display: boolean;
    currency?: string;
    options?: IEntryPageOption[];
}

export interface IWidgetConfiguration {
    merchantCode: string | null;
    showMarketingConsent: boolean;
    marketingConsentText: string | null;
    defaultOffsetAmount: number | null;
    defaultCurrency: string | null;
    hidePoweredBy: boolean;
    entryPage: IEntryPageConfiguration;
}

const defaultConfiguration = {
    merchantCode: null,
    showMarketingConsent: false,
    marketingConsentText: null,
    hidePoweredBy: false,
    hasContributionOptions: false,
    defaultOffsetAmount: 5,
    defaultCurrency: 'USD',
    entryPage: {
        display: false
    }
};

const configurations = [
    defaultConfiguration,
    {
        merchantCode: 'BUS_AE_EXPO_CITY_DUBAI',
        showMarketingConsent: true,
        marketingConsentText: 'I agree to receive communications from Expo City Dubai about news, events, and promotions.',
        hidePoweredBy: false,
        hasContributionOptions: false,
        defaultOffsetAmount: 5,
        defaultCurrency: 'USD',
        entryPage: {
            display: false
        }
    },
    {
        merchantCode: 'BUS_AE_DUBAI_AIRPORTS',
        showMarketingConsent: false,
        marketingConsentText: null,
        hidePoweredBy: false,
        hasContributionOptions: false,
        defaultOffsetAmount: 100,
        defaultCurrency: 'AED',
        entryPage: {
            display: false
        }
    },
    {
        merchantCode: 'BUS_US_OIETJHIOETJH',
        showMarketingConsent: true,
        marketingConsentText: 'I agree to receive communications from Alexander about news, events, and promotions.',
        hidePoweredBy: false,
        defaultOffsetAmount: 5,
        defaultCurrency: 'USD',
        entryPage: {
            display: true,
            currency: 'USD',
            options: [
                {
                    title: 'Local',
                    description: 'A contribution of $5 USD covers most ground travel up to 500 km.',
                    value: 5
                },
                {
                    title: 'Regional',
                    description: 'A contribution of $15 USD covers travel up to 1000 km and 3 nights at a 4 star hotel.',
                    value: 15
                },
                {
                    title: 'International',
                    description: 'A contribution of $30 USD offsets a long-haul flight in economy class and up to a week at a hotel.',
                    value: 30
                },
                {
                    title: 'TEST 1',
                    description: 'A contribution of $50 USD offsets a long-haul flight in economy class and up to a week at a hotel.',
                    value: 50
                },
                {
                    title: 'TEST 2',
                    description: 'A contribution of $100 USD offsets a long-haul flight in economy class and up to a week at a hotel.',
                    value: 100
                }
            ]
        }
    },
];

export const getConfiguration = (merchantCode: string):IWidgetConfiguration => {
    const configuration = configurations.find(config => config.merchantCode === merchantCode);
    return configuration || defaultConfiguration;
};